export default "__VITE_ASSET__DSf$n_EC__"